module.exports = __webpack_public_path__ + "static/img/qrcode.13e640f.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/qrcode.jpg
// module id = Hjk3
// module chunks = 1